export default class UpdateBrowserPhoneStatus {
  constructor(context) {
    this.context = context;
  }

  run() {
    let isWebRtcEnabled = this.context.stores.appFeatures.get().isEnabled('webRTC');
    if (!isWebRtcEnabled) {
      return;
    }

    let connectionStates = this.context.stores.connectionState.get();
    let storedBrowserPhoneStatus = connectionStates.getBrowserPhoneStatus();
    let currentBrowserPhoneStatus = this.context.gateways.phoneGateway.getDeviceStatus();

    // Update the store with the new device status
    if (storedBrowserPhoneStatus !== currentBrowserPhoneStatus) {
      connectionStates.updateTwilioStatus(currentBrowserPhoneStatus);
      this.context.stores.connectionState.set(connectionStates);
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/health/lib/update_browser_phone_status.js